import { useFeatureFlags } from 'utils/features';

export default function useWorkOrdersIsEnabled(): boolean {
  return useFeatureFlags('WORK_ORDERS');
}
